import axios from 'axios';
import { apiLambda } from './apiLambda';

interface IParams {
  consulta: string;
  telefone: string;
  email: string;
  cnpj: string;
  nome: string;
}

const contatoCommunix = async ({
  consulta,
  telefone,
  cnpj,
  email,
  nome
}: IParams) => {
  try {
    const response = await apiLambda.post(`comunix/contact/${consulta}`, {
      telefone,
      cnpj,
      email,
      nome
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export { contatoCommunix };
